export const API_URL =
  process.env.REACT_APP_API_URL || "https://api.getnovala.com";

export const getToken = (): string =>
  localStorage.getItem("access_token") || localStorage.getItem("token") || "";

export const authHeaders = (): Record<string, string> => ({
  Authorization: "Bearer " + getToken(),
  "Content-Type": "application/json",
});

export const formatPayDate = (date: Date | null | undefined): string =>
  date instanceof Date
    ? date.toLocaleDateString("en-GB", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    : "";

export const formatShortDate = (date: Date | null | undefined): string =>
  date instanceof Date
    ? date.toLocaleDateString("en-GB", { day: "numeric", month: "short" })
    : "";

export const money = (n: number | string | null | undefined): string =>
  "$" +
  (Number(n) || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });